module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 136,
	"w": 800,
	"h": 360,
	"nm": "Join us",
	"ddd": 0,
	"assets": [],
	"fonts": {
		"list": [
			{
				"fName": "LabilGrotesk-Bold",
				"fFamily": "Labil Grotesk",
				"fStyle": "Bold",
				"ascent": 69.9996948242188
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Shape Layer 1",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						400,
						180,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						95.952,
						95.952,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 13,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-34.5
													],
													[
														0,
														0
													],
													[
														0,
														31.5
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														36.5
													],
													[
														0,
														0
													],
													[
														0,
														-31.5
													]
												],
												"v": [
													[
														0,
														-60.5
													],
													[
														-10,
														-1.5
													],
													[
														0,
														61
													],
													[
														10.5,
														-1.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 14,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-34.5
													],
													[
														0,
														0
													],
													[
														0,
														12.38
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														29.118
													],
													[
														0,
														0
													],
													[
														0,
														-12.38
													]
												],
												"v": [
													[
														0,
														-28.713
													],
													[
														-2.184,
														-0.458
													],
													[
														0,
														24.524
													],
													[
														3.726,
														-1.437
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 17,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-34.5
													],
													[
														0,
														0
													],
													[
														0,
														31.5
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														36.5
													],
													[
														0,
														0
													],
													[
														0,
														-31.5
													]
												],
												"v": [
													[
														0,
														-60.5
													],
													[
														-11.042,
														-1.5
													],
													[
														0,
														61
													],
													[
														11.542,
														-1.5
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 32,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0.285,
														-73.726
													],
													[
														0,
														0
													],
													[
														0,
														93.528
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														-0.285,
														73.726
													],
													[
														0,
														0
													],
													[
														0,
														-78.433
													]
												],
												"v": [
													[
														0,
														-106.544
													],
													[
														-54.95,
														-1.816
													],
													[
														0,
														104.998
													],
													[
														56.493,
														-1.816
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 50,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														-0.232,
														-105.759
													],
													[
														0,
														0
													],
													[
														1.17,
														122.292
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0.266,
														121.25
													],
													[
														0,
														0
													],
													[
														-1.17,
														-122.292
													]
												],
												"v": [
													[
														0,
														-161.796
													],
													[
														-102.4,
														-1.399
													],
													[
														0,
														157.795
													],
													[
														103.049,
														-1.399
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 53,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-91.962
													],
													[
														0,
														0
													],
													[
														0,
														115.97
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														93.059
													],
													[
														0,
														0
													],
													[
														0,
														-113.311
													]
												],
												"v": [
													[
														0,
														-171.005
													],
													[
														-107.876,
														-1.33
													],
													[
														0,
														166.595
													],
													[
														110.461,
														-1.329
													]
												],
												"c": true
											}
										]
									},
									{
										"i": {
											"x": 0.667,
											"y": 1
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 82,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-130.772
													],
													[
														0,
														0
													],
													[
														0,
														129.852
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														131.258
													],
													[
														0,
														0
													],
													[
														0,
														-129.852
													]
												],
												"v": [
													[
														0,
														-181.431
													],
													[
														-158.162,
														-1.274
													],
													[
														0,
														176.273
													],
													[
														159.704,
														-1.274
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 120,
										"s": [
											{
												"i": [
													[
														0,
														0
													],
													[
														0,
														-161.665
													],
													[
														0,
														0
													],
													[
														0,
														161.412
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														161.665
													],
													[
														0,
														0
													],
													[
														0,
														-161.412
													]
												],
												"v": [
													[
														0,
														-189.731
													],
													[
														-185.087,
														-1.958
													],
													[
														0,
														183.977
													],
													[
														185.587,
														-1.958
													]
												],
												"c": true
											}
										]
									}
								],
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									0,
									0.312775675456,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 14,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 5,
			"nm": "Join US",
			"tt": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						400.17,
						178.149,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						-23,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 60,
								"f": "LabilGrotesk-Bold",
								"t": "JOIN US",
								"j": 2,
								"tr": 0,
								"lh": 72,
								"ls": 0,
								"fc": [
									0.949,
									0.941,
									0.89
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": [
					{
						"nm": "Animator 1",
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0,
								"ix": 7
							},
							"ne": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"a": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"e": {
								"a": 0,
								"k": 8,
								"ix": 5
							},
							"r": 2
						},
						"a": {
							"a": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 1
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0,
									0
								],
								"ix": 2
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100,
									100
								],
								"ix": 3
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 9
							}
						}
					}
				]
			},
			"ip": 14,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Höger mask",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 0,
						"k": 190,
						"ix": 3,
						"x": "var $bm_rt;\n$bm_rt = thisComp.layer('H\\xf6ger ram').transform.xPosition;"
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.90513197955,
									0.107275996489,
									0.107275996489,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Vänster fill",
			"tt": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.499
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 0,
								"s": [
									190
								]
							},
							{
								"t": 120,
								"s": [
									400
								]
							}
						],
						"ix": 3
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Vänster ram",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.499
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 0,
								"s": [
									190
								]
							},
							{
								"t": 120,
								"s": [
									400
								]
							}
						],
						"ix": 3
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "Vänster mask",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 0,
						"k": 190,
						"ix": 3,
						"x": "var $bm_rt;\n$bm_rt = thisComp.layer('V\\xe4nster ram').transform.xPosition;"
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.90513197955,
									0.107275996489,
									0.107275996489,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 4,
			"nm": "Höger fill",
			"tt": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.504
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 0,
								"s": [
									610
								]
							},
							{
								"t": 120,
								"s": [
									400
								]
							}
						],
						"ix": 3
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 4,
			"nm": "Höger ram",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"s": true,
					"x": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.504
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 0,
								"s": [
									610
								]
							},
							{
								"t": 120,
								"s": [
									400
								]
							}
						],
						"ix": 3
					},
					"y": {
						"a": 0,
						"k": 180,
						"ix": 4
					}
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": {
								"a": 0,
								"k": [
									356.336,
									356.336
								],
								"ix": 2
							},
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 3
							},
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.274509803922,
									1,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 2,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 4,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 136,
			"st": 0,
			"bm": 0
		}
	],
	"markers": [],
	"chars": [
		{
			"ch": "J",
			"size": 60,
			"style": "Bold",
			"w": 55.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-14.603,
												0
											],
											[
												0,
												14.905
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												5.338,
												0
											],
											[
												0,
												6.848
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												14.905,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												6.445
											],
											[
												-5.539,
												0
											],
											[
												0,
												0
											],
											[
												0,
												14.603
											]
										],
										"v": [
											[
												26.385,
												1.41
											],
											[
												51.562,
												-23.666
											],
											[
												51.562,
												-70.496
											],
											[
												35.349,
												-70.496
											],
											[
												35.349,
												-23.666
											],
											[
												26.486,
												-13.092
											],
											[
												17.221,
												-24.271
											],
											[
												1.813,
												-23.163
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "J",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "J",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "O",
			"size": 60,
			"style": "Bold",
			"w": 80.2,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-20.847,
												0
											],
											[
												0,
												20.847
											],
											[
												20.847,
												0
											],
											[
												0,
												-20.746
											]
										],
										"o": [
											[
												21.048,
												0
											],
											[
												0,
												-21.048
											],
											[
												-20.847,
												0
											],
											[
												0,
												21.048
											]
										],
										"v": [
											[
												40.384,
												2.014
											],
											[
												77.646,
												-35.248
											],
											[
												40.384,
												-72.51
											],
											[
												3.122,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												11.581,
												0
											],
											[
												0,
												13.193
											],
											[
												-11.581,
												0
											],
											[
												0,
												-13.293
											]
										],
										"o": [
											[
												-11.783,
												0
											],
											[
												0,
												-13.495
											],
											[
												11.783,
												0
											],
											[
												0,
												13.394
											]
										],
										"v": [
											[
												40.384,
												-12.488
											],
											[
												19.537,
												-35.248
											],
											[
												40.384,
												-58.109
											],
											[
												61.23,
												-35.248
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "O",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "O",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "I",
			"size": 60,
			"style": "Bold",
			"w": 27.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.841,
												0
											],
											[
												21.954,
												0
											],
											[
												21.954,
												-70.496
											],
											[
												5.841,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "I",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "I",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "N",
			"size": 60,
			"style": "Bold",
			"w": 71.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												5.035,
												0
											],
											[
												20.847,
												0
											],
											[
												20.041,
												-47.534
											],
											[
												50.354,
												0
											],
											[
												66.769,
												0
											],
											[
												66.769,
												-70.496
											],
											[
												50.958,
												-70.496
											],
											[
												51.764,
												-22.961
											],
											[
												21.451,
												-70.496
											],
											[
												5.035,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "N",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "N",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": " ",
			"size": 60,
			"style": "Bold",
			"w": 17.8,
			"data": {},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "U",
			"size": 60,
			"style": "Bold",
			"w": 69,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-18.228,
												0
											],
											[
												0,
												17.624
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												8.862,
												0
											],
											[
												0,
												9.668
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												18.228,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												9.668
											],
											[
												-8.862,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												17.624
											]
										],
										"v": [
											[
												34.744,
												1.41
											],
											[
												65.46,
												-28.198
											],
											[
												65.46,
												-70.496
											],
											[
												49.146,
												-70.496
											],
											[
												49.146,
												-28.702
											],
											[
												34.744,
												-13.092
											],
											[
												20.343,
												-28.702
											],
											[
												20.343,
												-38.672
											],
											[
												20.343,
												-70.496
											],
											[
												4.028,
												-70.496
											],
											[
												4.028,
												-38.672
											],
											[
												4.028,
												-28.198
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "U",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "U",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		},
		{
			"ch": "S",
			"size": 60,
			"style": "Bold",
			"w": 62,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-16.718,
												0
											],
											[
												0,
												13.495
											],
											[
												15.207,
												2.921
											],
											[
												0,
												0
											],
											[
												0,
												4.23
											],
											[
												-6.244,
												0
											],
											[
												-0.201,
												-7.15
											],
											[
												0,
												0
											],
											[
												15.811,
												0
											],
											[
												0,
												-13.193
											],
											[
												-14.905,
												-2.921
											],
											[
												0,
												0
											],
											[
												0,
												-3.827
											],
											[
												6.647,
												0
											],
											[
												0,
												7.251
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												16.415,
												0
											],
											[
												0,
												-11.38
											],
											[
												0,
												0
											],
											[
												-4.935,
												-1.007
											],
											[
												0,
												-4.935
											],
											[
												6.949,
												0
											],
											[
												0,
												0
											],
											[
												-0.403,
												-13.998
											],
											[
												-15.912,
												0
											],
											[
												0,
												11.783
											],
											[
												0,
												0
											],
											[
												4.733,
												1.007
											],
											[
												0,
												5.035
											],
											[
												-7.755,
												0
											],
											[
												0,
												0
											],
											[
												0,
												14.2
											]
										],
										"v": [
											[
												31.219,
												1.913
											],
											[
												59.015,
												-20.847
											],
											[
												36.456,
												-42.096
											],
											[
												28.5,
												-43.607
											],
											[
												20.947,
												-51.663
											],
											[
												31.622,
												-59.921
											],
											[
												43.707,
												-47.736
											],
											[
												59.619,
												-48.642
											],
											[
												32.126,
												-72.409
											],
											[
												5.035,
												-50.153
											],
											[
												26.99,
												-28.4
											],
											[
												34.946,
												-26.889
											],
											[
												42.902,
												-19.336
											],
											[
												31.723,
												-10.776
											],
											[
												18.631,
												-23.163
											],
											[
												2.82,
												-22.156
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "S",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "S",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "Labil Grotesk"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/Join_us.json
// module id = 48
// module chunks = 0